"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTargetFrameworksFromProjFile = getTargetFrameworksFromProjFile;
const errors_1 = require("../../errors");
const fs = require("fs");
const path = require("path");
const parseXML = require("xml2js");
const debugModule = require("debug");
const framework_1 = require("../framework");
const debug = debugModule('snyk');
function findFile(rootDir, filter) {
    if (!fs.existsSync(rootDir)) {
        throw new errors_1.FileNotFoundError('No such path: ' + rootDir);
    }
    const files = fs.readdirSync(rootDir);
    for (const file of files) {
        const filename = path.resolve(rootDir, file);
        if (filter.test(filename)) {
            return filename;
        }
    }
    return;
}
function getTargetFrameworksFromProjFile(rootDir) {
    debug('Looking for your .csproj file in ' + rootDir);
    const csprojPath = findFile(rootDir, /.*\.csproj$/);
    if (!csprojPath) {
        debug('.csproj file not found in ' + rootDir + '.');
        return [];
    }
    debug(`Checking .NET framework version in .csproj file ${csprojPath}`);
    const csprojContents = fs.readFileSync(csprojPath, 'utf-8');
    let result = [];
    parseXML.parseString(csprojContents, (err, parsedCsprojContents) => {
        var _a, _b;
        if (err) {
            throw new errors_1.FileNotProcessableError(err);
        }
        const parsedTargetFrameworks = ((_b = (_a = parsedCsprojContents === null || parsedCsprojContents === void 0 ? void 0 : parsedCsprojContents.Project) === null || _a === void 0 ? void 0 : _a.PropertyGroup) === null || _b === void 0 ? void 0 : _b.reduce((targetFrameworks, propertyGroup) => {
            var _a, _b, _c;
            const targetFrameworkSource = ((_a = propertyGroup === null || propertyGroup === void 0 ? void 0 : propertyGroup.TargetFrameworkVersion) === null || _a === void 0 ? void 0 : _a[0]) ||
                ((_b = propertyGroup === null || propertyGroup === void 0 ? void 0 : propertyGroup.TargetFramework) === null || _b === void 0 ? void 0 : _b[0]) ||
                ((_c = propertyGroup === null || propertyGroup === void 0 ? void 0 : propertyGroup.TargetFrameworks) === null || _c === void 0 ? void 0 : _c[0]) ||
                '';
            return targetFrameworks
                .concat(targetFrameworkSource.split(';'))
                .filter(Boolean);
        }, [])) || [];
        if (parsedTargetFrameworks.length < 1) {
            debug('Could not find TargetFrameworkVersion/TargetFramework' +
                '/TargetFrameworks defined in the Project.PropertyGroup field of ' +
                'your .csproj file');
            result = [];
            return;
        }
        const targetFrameworks = parsedTargetFrameworks
            .map(framework_1.toReadableFramework)
            .filter(Boolean);
        if (parsedTargetFrameworks.length > 1 && targetFrameworks.length < 1) {
            debug('Could not find valid/supported .NET version in csproj file located at' +
                csprojPath);
        }
        result = targetFrameworks;
        return;
    });
    return result;
}
//# sourceMappingURL=csproj-parser.js.map